
import React from "react";
import { Navigation } from "@/components/Navigation";
import { ScrollToTop } from "@/components/ScrollToTop";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { QrCode, Activity } from "lucide-react";
import { useCongregationData } from "@/hooks/use-congregation-data";
import { CongregationPrayerRequests } from "@/components/admin/CongregationPrayerRequests";
import { CongregationOverview } from "@/components/admin/CongregationOverview";
import { BraceletActivityTable } from "@/components/admin/BraceletActivityTable";
import { BraceletCodesDialog } from "@/components/admin/BraceletCodesDialog";
import { Badge } from "@/components/ui/badge";

export default function CongregationsPage() {
  const {
    loading,
    showBraceletCodes,
    setShowBraceletCodes,
    braceletCodes,
    prayerRequests,
    loadingPrayers,
    braceletActivity,
    congregationName,
    churchCode,
    logo,
    congregationStats,
    viewBraceletCodes
  } = useCongregationData();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 pb-20">
      <ScrollToTop />
      
      <main className="container mx-auto px-4 py-8">
        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center">
            {logo && (
              <img 
                src={logo} 
                alt={`${congregationName} Logo`}
                className="h-10 w-10 mr-3 object-contain"
              />
            )}
            <div>
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                {congregationName} Dashboard
              </h1>
              <div className="flex items-center mt-1">
                <Badge variant="outline" className="flex items-center gap-1 text-xs bg-green-50 text-green-800 border-green-200">
                  <Activity className="h-3 w-3" />
                  Live Updates
                </Badge>
              </div>
            </div>
          </div>
          <Button onClick={viewBraceletCodes}>
            View All Bracelets
          </Button>
        </div>

        <CongregationPrayerRequests 
          prayerRequests={prayerRequests}
          loadingPrayers={loadingPrayers}
          congregationName={congregationName}
        />

        {loading ? (
          <div className="flex justify-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-500"></div>
          </div>
        ) : (
          <>
            <CongregationOverview 
              stats={congregationStats}
              congregationName={congregationName}
            />
            
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center">
                  <QrCode className="mr-2 h-5 w-5" />
                  Bracelet Activity
                </CardTitle>
              </CardHeader>
              <CardContent>
                <BraceletActivityTable 
                  braceletActivity={braceletActivity}
                  isLoading={loading}
                />
              </CardContent>
            </Card>
          </>
        )}
      </main>

      <BraceletCodesDialog
        open={showBraceletCodes}
        onOpenChange={setShowBraceletCodes}
        braceletCodes={braceletCodes}
        congregationName={congregationName}
        churchCode={churchCode || ""}
      />

      <Navigation />
    </div>
  );
}
